export default __webpack_public_path__ + "static/tough-mudder-group-9bdae8e5894b807c6dde24c8811e7d87.jpg";